export enum VoucherType {
  PercentageDiscount = 'PercentageDiscount',
  LumpDiscount = 'LumpDiscount',
  AddItem = 'AddItem',
  CreditNote = 'CreditNote',
  FreeDelivery = 'FreeDelivery',
}

export enum VoucherSubType {
  None = 'None',
  SignUp = 'SignUp',
  Loyalty = 'Loyalty',
  Loyalty25 = 'Loyalty25',
  Retention = 'Retention',
  SecondaryRetention = 'SecondaryRetention',
  Custom = 'Custom',
}

export type AssignedVoucher = {
  voucherId: number;
  code: string | null;
  description: string | null;
  status: 'Valid' | 'NotYetValid' | 'Expired' | 'Used' | 'Disabled' | string;
  voucherType: VoucherType | string;
  voucherSubType: VoucherSubType | string;
  isEnabled: boolean;
  startDate: string | null;
  expiryDate: string | null;
  customerId: number;
};
